module.exports = __webpack_public_path__ + "img/ic_Zip_1.4cbae713.svg";